module.exports = __webpack_public_path__ + "img/map_world.c2878d7b.png";